import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, IconButton, Drawer,
  Card, CardHeader, CardText, CircularProgress,
} from "material-ui";
import Editar from "material-ui/svg-icons/image/edit";
import Eliminar from "material-ui/svg-icons/action/delete";
import { OpenEliminarPrestacion, OpenEditarPrestacion, SeleccionarPrestacionEliminar, SeleccionarPrestacionEditar } from "./actions";
import EliminarPrestacionForm from "../EliminarPrestacionForm/view";
import EditarPrestacionForm from "../EditarPrestacionForm/view";
import { ObtenerDetallePrestacionEdicion, ObtenerCentrosAtencionPorPrestacion } from "../EditarPrestacionForm/actions";
import { ObtenerDetallePrestacionEliminacion, ObtenerCentrosAtencionPorPrestacionEli } from "../EliminarPrestacionForm/actions";


import styles from "../../styles/styles";
import PaginacionBd from "../../PaginacionV2/view";


class GrillaBusqueda extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      listaItems: [],
    }
  }

  componentWillMount() { }

  EditEnabled = (idPrestacion, CodPrestacion, CodProf, TipoAtencion) => {
    let result = false;
    this.props.prestacionesSolicitud.forEach((item) => {
      if (idPrestacion === item.IDPRESTACION && CodPrestacion === item.COD_PRESTADOR
        && (CodProf === item.PROF_CCOD || item.PROF_CCOD === "**") && (TipoAtencion === item.TIPO_ATENCION || typeof item.TIPO_ATENCION === "undefined")) {
        result = true;
      }
    });

    return result;
  }
  OpenEliminarPrestacion = (idPrestacion, CodPrestacion, CodProf, TipoAtencion) => {
    this.props.dispatch(SeleccionarPrestacionEliminar(idPrestacion));
    this.props.dispatch(ObtenerCentrosAtencionPorPrestacionEli(idPrestacion, CodPrestacion, CodProf, TipoAtencion, this.props.tipoArancel, this.props.rutInstitucion, this.props.isapre));
    this.props.dispatch(ObtenerDetallePrestacionEliminacion(idPrestacion, this.props.isapre, OpenEliminarPrestacion));
  }

  OpenEditarPrestacion = (idPrestacion, CodPrestacion, CodProf, TipoAtencion) => {
    this.props.dispatch(SeleccionarPrestacionEditar(idPrestacion));
    this.props.dispatch(ObtenerCentrosAtencionPorPrestacion(idPrestacion, CodPrestacion, CodProf, TipoAtencion, this.props.tipoArancel, this.props.rutInstitucion, this.props.isapre));
    this.props.dispatch(ObtenerDetallePrestacionEdicion(idPrestacion, this.props.isapre, OpenEditarPrestacion));
  }

  // callbackFunction = (childData) => {
  //   this.setState({ listaItems: childData });
  // }

  render() {

    const menuListprestaciones = [];

    this.props.prestaciones.map((row, index) => (
      menuListprestaciones.push((
        <TableRow key={index}>
          <TableRowColumn id={row.ID} name={`ID_${row.ID}`} style={{ visibility: "hidden" }}>{row.ID}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda1}>{row.COD_PRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda2} title={row.GLOSA_CODPRESTADOR}>{row.GLOSA_CODPRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda3}>{row.COD_ISAPRE}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda4}>{row.PROF_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda5}>{row.VALOR}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda7}>{row.UNIDAD === "VE" ? "VF" : row.UNIDAD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda6}>{row.TIPO_ATENCION === "A" ? "AMBULATORIA" : "HOSPITALARIA"}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda8}>{(new Date(row.INICIO_VIG)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda9}>{row.CENTRO_AT}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda10}>
            {!this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION) ?
              <IconButton
                iconStyle={styles.svgStyleResultado}
                style={styles.iconStyleResultado}
                // disabled={this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
                onClick={() => this.OpenEditarPrestacion(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
              >
                <Editar />
              </IconButton> : null}
          </TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda11}>
            {!this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION) ?
              <IconButton
                iconStyle={styles.svgStyleResultado}
                style={styles.iconStyleResultado}
                onClick={() => this.OpenEliminarPrestacion(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
              >
                <Eliminar />
              </IconButton> : null}
          </TableRowColumn>
        </TableRow>
      ))
    ));

    return (
      <div>
        <div style={{ padding: "5px" }}>
          <Card
            initiallyExpanded
            zDepth={0}
          >
            <CardHeader
              actAsExpander
              showExpandableButton
              iconStyle={{ height: 20, width: 20, color: "#212121" }}
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "1290px", overflow: "auto",
              }}
            >
              <div style={styles.h1}>Resultado Búsqueda</div>
            </CardHeader>
            <CardText
              expandable
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
              }}
            >
              {!this.props.loading ?
                <div>
                  {(!this.props.prestaciones || this.props.prestaciones.length === 0) ?
                    <span style={{ textAlign: "left" }}>
                      {this.props.loading != null ? "No se encontraron resultados" : "-"}
                    </span>
                    :
                    <div>
                      {/* <div id="tablaBusquedaPrestaciones" style={{ overflow: "auto" }}>
                        <div style={{ width: "1500px", overflowX: "auto", textAlign: "left" }}>
                          <Table
                            key="tablaBusquedaPrestaciones"

                            fixedHeader
                            selectable={false}
                            style={{ overflow: "hidden" }}
                          >
                            <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                              <TableRow selectable={false}>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda1}>Código<br />Prestación</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda2}>Glosa Prestación</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda3}>Código<br />Isapre/Fonasa</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda4}>Código<br />Profesional</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda5}>Valor</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda7}>Unidad</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda6}>Tipo<br />Atención</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda8}>Fecha<br />Vigencia Precio</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda9}>Centro Atención</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda10}>Editar</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusqueda11}>Eliminar</TableHeaderColumn>
                              </TableRow>
                            </TableHeader>
                            <TableBody
                              id="tablaBodyBusquedaPrestaciones"
                              displayRowCheckbox={false}
                              deselectOnClickaway={false}
                              stripedRows
                            >
                              {menuListprestaciones}
                            </TableBody>
                          </Table>
                        </div>
                      </div> */}
                      <PaginacionBd
                        idTabla="tablaBusquedaPrestaciones"
                        parentCallback={this.callbackFunction}
                        tipoArancel={this.props.tipoArancel}
                        rutInstitucion={this.props.rutInstitucion}
                        isapre={this.props.isapre}
                        key="pag_tablaBodyBusquedaPrestaciones"
                        rowsPerPageDefault={5} // [5,10,15,20,25]
                        totalRows={menuListprestaciones.length}
                        pageDefault={1}
                        totalPagina={5}
                        idTableBody="tablaBodyBusquedaPrestaciones"
                        showRowsPerPage={false}
                        labelStyleBtnPage={{ fontSize: "11px" }}
                        overlayStyleBtnPage={{ borderRadius: 20 }}
                        rippleStyleBtnPage={{ borderRadius: 20 }}
                        buttonStyleBtnPage={{ borderRadius: 20 }}
                        styleBtnPage={{
                          paddingLeft: 0,
                          paddingRight: 0,
                          paddingTop: 0,
                          paddingBottom: 0,
                          height: 25,
                          width: "45px",
                          minWidth: "45px",
                          borderRadius: 20,
                          marginRight: 5,
                        }}

                        labelStyleRowsPerPage={styles.h4}
                        underlineStyleRowsPerPage={styles.underlineSelectField}
                        iconStyleRowsPerPage={styles.iconSelectField}
                        menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                        selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                        styleRowsPerPage={styles.selectFiledStyle}
                      />
                      {/* <TablePaginationCustom
                        key="pag_tablaBodyBusquedaPrestaciones"
                        rowsPerPageDefault={5} // [5,10,15,20,25]
                        totalRows={menuListprestaciones.length}
                        pageDefault={1}
                        idTableBody="tablaBodyBusquedaPrestaciones"
                        showRowsPerPage={false}
                        labelStyleBtnPage={{ fontSize: "11px" }}
                        overlayStyleBtnPage={{ borderRadius: 20 }}
                        rippleStyleBtnPage={{ borderRadius: 20 }}
                        buttonStyleBtnPage={{ borderRadius: 20 }}
                        styleBtnPage={{
                          paddingLeft: 0,
                          paddingRight: 0,
                          paddingTop: 0,
                          paddingBottom: 0,
                          height: 25,
                          width: "45px",
                          minWidth: "45px",
                          borderRadius: 20,
                          marginRight: 5,
                        }}

                        labelStyleRowsPerPage={styles.h4}
                        underlineStyleRowsPerPage={styles.underlineSelectField}
                        iconStyleRowsPerPage={styles.iconSelectField}
                        menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                        selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                        styleRowsPerPage={styles.selectFiledStyle}
                      /> */}
                    </div>
                  }

                </div>
                :
                <CircularProgress />
              }
            </CardText>
          </Card>
        </div>
        <Drawer
          width="100%"
          openSecondary
          open={this.props.modalEliminarPrestacion}
          docked={false}
        >
          {(this.props.modalEliminarPrestacion) ?
            <EliminarPrestacionForm CambiosSinGuardar={this.props.CambiosSinGuardar} />
            : null}
        </Drawer>

        <Drawer
          width="100%"
          openSecondary
          open={this.props.modalEditarPrestacion}
          docked={false}
        >
          {(this.props.modalEditarPrestacion) ?
            <EditarPrestacionForm CambiosSinGuardar={this.props.CambiosSinGuardar} />
            : null}
        </Drawer>
      </div>
    );
  }
}

GrillaBusqueda.defaultProps = {
  rutInstitucion: null,
  loading: null,
};

GrillaBusqueda.propTypes = {
  prestaciones: PropTypes.array.isRequired,
  modalEditarPrestacion: PropTypes.bool.isRequired,
  modalEliminarPrestacion: PropTypes.bool.isRequired,
  // idPrestacionEditar: PropTypes.number.isRequired,
  // idPrestacionEliminar: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  tipoArancel: PropTypes.number.isRequired,
  rutInstitucion: PropTypes.number,
  isapre: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
  prestacionesSolicitud: PropTypes.array.isRequired,
  listaItems: PropTypes.array.isRequired,
  prestacionesPP: PropTypes.array,
};

const mapStateToProps = (state) => ({
  prestaciones: state.filtroBusqueda.prestaciones,
  modalEditarPrestacion: state.grillaBusqueda.modalEditarPrestacion,
  modalEliminarPrestacion: state.grillaBusqueda.modalEliminarPrestacion,
  // idPrestacionEditar: state.grillaBusqueda.idPrestacionEditar,
  // idPrestacionEliminar: state.grillaBusqueda.idPrestacionEliminar,
  loading: state.filtroBusqueda.loading,
  tipoArancel: state.global.filtros_CAT.tipoArancel || 0,
  rutInstitucion: state.global.rutInstitucion,
  isapre: state.global.isapre,
  prestacionesSolicitud: state.grillaSolicitud.prestacionesSolicitud,
  prestacionesPP: state.paginacionState.prestaciopnesPP,
  tablaBody: state.paginacionState.tablaBody,

});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(GrillaBusqueda);



// WEBPACK FOOTER //
// ./src/components/ActualizarArancel/GrillaBusqueda/view.jsx